import {apiClient} from './axios';
import type {IapProduct, IapProductCreateReq, IapProductUpdateReq, SyncFromStoresRes} from '../types/iap';

export const iapApi = {
    getAll: () =>
        apiClient.get<IapProduct[]>('/admin/iap/products'),

    getOne: (id: number) =>
        apiClient.get<IapProduct>(`/admin/iap/products/${id}`),

    create: (data: IapProductCreateReq) =>
        apiClient.post<IapProduct>('/admin/iap/products', data),

    update: (id: number, data: IapProductUpdateReq) =>
        apiClient.patch<IapProduct>(`/admin/iap/products/${id}`, data),

    delete: (id: number) =>
        apiClient.deleteNoData(`/admin/iap/products/${id}`),

    syncFromStores: async () => {
        const res = await apiClient.post<SyncFromStoresRes>('/admin/iap/products/sync-from-stores');
        return {...res, errors: res.errors ?? [], products: res.products ?? []};
    },
};
